const routes = {
  comment: '/opmerkingen',
  serviceAdvisorName: '/naam',
};

export default routes;
